<mat-sidenav-container class="sidenav-container">
  <!-- Sidebar -->
  <mat-sidenav
    #sidenav
    [mode]="sidenavMode"
    [opened]="sidenavOpened"
    [class.collapsed]="isSidebarCollapsed"
    class="sidenav collapsed"
    autosize
  >
    <div class="sidenav-header">
      <button
        mat-icon-button
        (click)="toggleSidebar()"
        [attr.aria-label]="
          isSidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'
        "
        [title]="
          isSidebarCollapsed
            ? 'Expand sidebar (Ctrl+B)'
            : 'Collapse sidebar (Ctrl+B)'
        "
      >
        <mat-icon>{{
          isSidebarCollapsed ? "chevron_right" : "chevron_left"
        }}</mat-icon>
      </button>
    </div>
    <div class="sidenav-list-container">
      <!-- Main Navigation -->
      <mat-nav-list class="sidenav-list">
        @if (canViewUsersManagement) {
          <div class="sidenav-item-container">
            <a
              mat-list-item
              class="sidenav-item"
              routerLink="/admin/users"
              routerLinkActive="active"
              title="Resources"
              (click)="onNavItemClick()"
            >
              <div class="sidenav-item-content">
                <mat-icon matListItemIcon>people</mat-icon>
                <span matListItemTitle class="sidebar-text">Resources</span>
              </div>
            </a>
          </div>
        }

        @if (!isLoadingFeatureFlags) {
          @if (isRoleManagementEnabled && canViewPermissionsManagement) {
            <div class="sidenav-item-container">
              <a
                mat-list-item
                class="sidenav-item"
                routerLink="/admin/roles"
                routerLinkActive="active"
                title="Roles"
                (click)="onNavItemClick()"
              >
                <div class="sidenav-item-content">
                  <mat-icon matListItemIcon>admin_panel_settings</mat-icon>
                  <span matListItemTitle class="sidebar-text">Roles</span>
                </div>
              </a>
            </div>
          }
          @if (isPracticeAreaEnabled && canViewPracticeAreasManagement) {
            <div class="sidenav-item-container">
              <a
                mat-list-item
                class="sidenav-item"
                routerLink="/admin/practice-areas"
                routerLinkActive="active"
                title="Practice Areas"
                (click)="onNavItemClick()"
              >
                <div class="sidenav-item-content">
                  <mat-icon matListItemIcon>category</mat-icon>
                  <span matListItemTitle class="sidebar-text"
                    >Practice Areas</span
                  >
                </div>
              </a>
            </div>
          }
          <div class="sidenav-item-container">
            <a
              mat-list-item
              class="sidenav-item"
              routerLink="/admin/offices"
              routerLinkActive="active"
              title="Offices"
              (click)="onNavItemClick()"
            >
              <div class="sidenav-item-content">
                <mat-icon matListItemIcon>location_city</mat-icon>
                <span matListItemTitle class="sidebar-text">Offices</span>
              </div>
            </a>
          </div>
          @if (isAuditHistoryEnabled && canViewAuditHistory) {
            <div class="sidenav-item-container">
              <a
                mat-list-item
                class="sidenav-item"
                routerLink="/admin/audit-history"
                routerLinkActive="active"
                title="Audit History"
                (click)="onNavItemClick()"
              >
                <div class="sidenav-item-content">
                  <mat-icon matListItemIcon>history</mat-icon>
                  <span matListItemTitle class="sidebar-text"
                    >Audit History</span
                  >
                </div>
              </a>
            </div>
          }
          @if (isSystemLogsEnabled && canViewLogs) {
            <div class="sidenav-item-container">
              <a
                mat-list-item
                class="sidenav-item"
                routerLink="/admin/logs"
                routerLinkActive="active"
                title="System Logs (Super Admin Only)"
                (click)="onNavItemClick()"
              >
                <div class="sidenav-item-content">
                  <mat-icon matListItemIcon>browse_activity</mat-icon>
                  <span matListItemTitle class="sidebar-text">System Logs</span>
                </div>
              </a>
            </div>
          }
          @if (isFeatureFlagManagementEnabled && canViewFeatureFlagManagement) {
            <div class="sidenav-item-container">
              <a
                mat-list-item
                class="sidenav-item"
                routerLink="/admin/feature-flags"
                routerLinkActive="active"
                title="Feature Flags (Super Admin Only)"
                (click)="onNavItemClick()"
              >
                <div class="sidenav-item-content">
                  <mat-icon matListItemIcon>flag</mat-icon>
                  <span matListItemTitle class="sidebar-text">Features</span>
                </div>
              </a>
            </div>
          }
          @if (canViewAppSettingsManagement) {
            <div class="sidenav-item-container">
              <a
                mat-list-item
                class="sidenav-item"
                routerLink="/admin/app-settings"
                routerLinkActive="active"
                title="App Settings"
                (click)="onNavItemClick()"
              >
                <div class="sidenav-item-content">
                  <mat-icon matListItemIcon>settings_applications</mat-icon>
                  <span matListItemTitle class="sidebar-text"
                    >App Settings</span
                  >
                </div>
              </a>
            </div>
          }
          @if (canViewUserFeedback) {
            <div class="sidenav-item-container">
              <a
                mat-list-item
                class="sidenav-item"
                routerLink="/admin/user-feedback"
                routerLinkActive="active"
                title="User Feedback"
                (click)="onNavItemClick()"
              >
                <div class="sidenav-item-content">
                  <mat-icon matListItemIcon>rate_review</mat-icon>
                  <span matListItemTitle class="sidebar-text"
                    >User Feedback</span
                  >
                </div>
              </a>
            </div>
          }
        }
      </mat-nav-list>
    </div>
  </mat-sidenav>

  <!-- Main Content -->
  <mat-sidenav-content class="page-container">
    <div class="page-main">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
